module.exports = __webpack_public_path__ + "picks.png?77f145e29211081bc34b5f2565d641d3";